// utils/rolePermissions/rolesC.ts - utils/rolePermissions/permissions.ts object split (part rolesC)


export const rolesC = {

  'Advertiser': {
    menus: [
      'dashboard',
      // Full access to product management
      'products', 'product_list', 'form_list', 'product_page', 'digital_products',
      // Order management - view only
      'orders', 'order_list', 'abandoned_carts', 'digital_orders',
      // Customer management
      'customers',
      // Reports and analytics
      'reports', 'ad_reports', 'analytics_dashboard',
      // Earnings
      'earnings',
      // WA Bot & Prospek
      'wa_bot', 'prospek',
      // Iklan
      'iklan_automation'
    ],
    features: [
      // Data export
      'export_csv',
      // Product management - full access
      'edit_product', 'delete_product', 'edit_form', 'delete_form', 'edit_landing_page',
      // Order management - view and basic management
      'change_order_status', 'manual_order_creation',
      // Financial access
      'view_earnings',
      // Dashboard widgets
      'view_sales_stats', 'view_charts', 'view_top_products', 'view_top_advertisers',
      'view_recent_orders',
      // Reports
      'view_reports',
      // Iklan
      'manage_ads_automation'
    ],
  },

  'Partner': {
    menus: [
      'dashboard',
      'orders', 'order_list', 'digital_orders',
      'reports', 'ad_reports', 'analytics_dashboard',
      'wa_bot', 'prospek'
    ],
    features: [
      'view_reports',
      'view_sales_stats', 'view_charts'
    ],
  }
};

